import React from 'react';
import {AssetTypeFormProps} from '../interfaces';
import {
  AssetSizeSelect,
  ChassisNumberField,
  ChassisLicensePlateField,
  DriverFields,
  ScacCodeField,
  TruckLicensePlateField,
  NotesField,
} from '../fields';

/**
 * Check-in form for Chassis Only asset type.
 * Covers: CHASSIS_ONLY.
 *
 * Required fields: Chassis Number, Driver License Number, Driver First Name,
 *                  Driver Last Name.
 * Optional fields: Asset Size (rendered but not required).
 */
const ChassisOnlyForm: React.FC<AssetTypeFormProps> = ({form, errors, onValueChange, onAssetSizeChange}) => {
  return (
    <>
      <AssetSizeSelect
        value={form.assetSize}
        onChange={onAssetSizeChange}
      />
      <ChassisNumberField
        value={form.chassisNumber}
        onValueChange={onValueChange}
        error={errors.chassisNumber}
        required
      />
      <ChassisLicensePlateField
        value={form.chassisLicensePlateNumber}
        onValueChange={onValueChange}
      />
      <DriverFields
        form={form}
        errors={errors}
        onValueChange={onValueChange}
        requireLicense
      />
      <ScacCodeField
        value={form.scacCode}
        onValueChange={onValueChange}
        error={errors.scacCode}
      />
      <TruckLicensePlateField
        value={form.truckLicensePlateNumber}
        onValueChange={onValueChange}
        error={errors.truckLicensePlateNumber}
      />
      <NotesField
        value={form.notes}
        onValueChange={onValueChange}
      />
    </>
  );
};

export default ChassisOnlyForm;

